import { useEffect } from 'react';
import { Link } from 'react-router-dom';

export default function NotFoundPage() {
  useEffect(() => {
    document.title = '404 — Page Not Found';
  }, []);

  return (
    <div className="wrap">
      <div className="not-found">
        <h1>404</h1>
        <h2>Page not found</h2>
        <p>The page you're looking for doesn't exist.</p>
        <p><Link to="/">← Go home</Link></p>
      </div>
    </div>
  );
}
